import { useContext, useMemo } from 'react';
import { DrawerContext } from '@timeedit/ui-components';
import { Grid } from '@timeedit/ui-components/antd';

const { useBreakpoint } = Grid;

const getBreakpointMap = (expanded: boolean) => {
  if (!expanded) {
    return {
      labelCol: {
        xs: 12,
        sm: 12,
        md: 12,
        lg: 10,
        xl: 10,
      },
      wrapperCol: {
        xs: 12,
        sm: 12,
        md: 12,
        lg: 14,
        xl: 14,
      },
    };
  }

  return {
    labelCol: {
      span: 10,
    },
    wrapperCol: {
      span: 14,
    },
  };
};

export const useResponsiveDrawerColumns = (
  config: ColumnConfig = defaultColumnConfig
) => {
  const screens = useBreakpoint();
  const { isExpanded: isDrawerExpanded } = useContext(DrawerContext);
  const nbrOfColumns = useMemo<number>(() => {
    if (!isDrawerExpanded) {
      return config.sm;
    }
    if (screens.xxl) {
      return config.xxl;
    }
    if (screens.xl) {
      return config.xl;
    }
    if (screens.lg) {
      return config.lg;
    }
    return config.sm;
  }, [screens, isDrawerExpanded, config]);

  const formLayout = getBreakpointMap(isDrawerExpanded);

  return { nbrOfColumns, formLayout };
};

type ColumnConfig = {
  xxl: number;
  xl: number;
  lg: number;
  sm: number;
};

const defaultColumnConfig: ColumnConfig = {
  xxl: 3,
  xl: 3,
  lg: 2,
  sm: 1,
};
